export enum Errors {
    NameExistenceError = 'aumico_notes_name_exist_error',
    ServerError = 'aumico_notes_server_error',
    MinNameLengthIs_5 = 'aumico_notes_notestype_form_min_length_error',
    MandatoryFieldError = 'aumico_core_form_mandatory_error',
    legal_From_And_Account_Basis_Combination_Error = 'aumico_notes_notestemplate_form_legal_form_and_accounting_basis_combination_exist',
    Not_Found = 'aumico_notes_notespage_notes_not_found',
}
